var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"ScrollXNavbarCmp",style:({'height': `${_vm.height}px`})},[_c('ul',{on:{"mousedown":_vm.mouseDownHandler}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }